export const  resourceTypes  = {
    devices: "devices",
    transfer: "transfer",
    users: "organizationMembers",
}